import { GetHisReading, GetMonitorSensor } from '../../Api/getData';
import useDashboardResource from '../Dashboard/useDashboardResource';

function arrayResponse(data) {
    if (!Array.isArray(data) || data.some(row => !row || typeof row !== 'object' || row.ErrorMessage)) throw Error('Invalid History response');
    return data;
}
const loadSensors = (_, params, signal) => GetMonitorSensor(params, signal).then(arrayResponse);
const loadReadings = (_, params, signal) => GetHisReading(params, signal).then(arrayResponse).then(rows => rows.filter(row => row.AccountId === params.AccountId && row.ObjectCode === params.ObjectCode && row.SensorCode && row.RefDate));
export default function useHistoryData(vessel, filter, refresh) {
    const identity = { AccountId: vessel?.accountId, ObjectCode: vessel?.objectCode };
    const sensors = useDashboardResource(loadSensors, '', identity, !!vessel, refresh);
    const dates = { ...identity, StartDate: filter.start, EndDate: filter.end };
    const readings = useDashboardResource(loadReadings, '', { ...dates, SensorCode: filter.sensors.includes('All') ? '' : filter.sensors.join(','), Time: filter.interval }, !!vessel, refresh);
    return { sensors, readings };
}
